import { render, staticRenderFns } from "./DashChart.vue?vue&type=template&id=155a6b3c"
import script from "./DashChart.vue?vue&type=script&lang=js"
export * from "./DashChart.vue?vue&type=script&lang=js"
import style0 from "./DashChart.vue?vue&type=style&index=0&id=155a6b3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports